exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mobile #noteNote[data-v-7bd11153]{height:100%;font-size:1.8rem}.mobile .content textarea[data-v-7bd11153]{width:100%;heigth:100%;overflow:auto}.mobile .content>[data-v-7bd11153]:last-child{margin-bottom:0}", ""]);

// exports
